import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import {
  CasoTareaService,
  CasoTareaModel,
} from 'src/app/services/casos_tareas.service';
import { AgregarTareasComponent } from '../agregar-tareas/agregar-tareas.component';
import { MatDialog } from '@angular/material/dialog';
import { TareasService } from 'src/app/services/tareas.service';
import {
  TareaCasoService,
  TareaCasoModel,
  TareaCasoMixedModel,
} from 'src/app/services/tareacaso.service';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { VerTareaComponent } from '../ver-tarea/ver-tarea.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificacionService } from 'src/app/services/notificaciones.service';
import { first } from 'rxjs/operators';
import { Socket } from 'ngx-socket-io';
import { RolService } from 'src/app/services/rol.service';
import { UserService } from 'src/app/services/user.service';
import { RolesPermisosService } from 'src/app/services/roles_permisos.service';
import { CaseInformationComponent } from './case-information/case-information.component';
import { EnvService } from 'src/app/services/env.service';

@Component({
  selector: 'detalle-caso',
  templateUrl: './detalle-caso.component.html',
  styleUrls: ['./detalle-caso.component.scss'],
})
export class DetalleCaso implements OnInit {
  @ViewChild(CaseInformationComponent)
  caseInformation: CaseInformationComponent;

  requerido: boolean = false;

  idCaso: string = '';

  caso: CasoTareaModel = null;

  tareasCaso: TareaCasoModel[] = [];

  tareas: TareaCasoMixedModel[] = [];

  tareasShow: TareaCasoMixedModel[] = [];

  tareasOriginal: TareaCasoMixedModel[] = [];

  pendientePorRealizar: TareaCasoMixedModel[] = [];

  enEjecucion: TareaCasoMixedModel[] = [];

  finalizado: TareaCasoMixedModel[] = [];

  processingInit: boolean = false;

  pendientePorRealizarshow: TareaCasoMixedModel[] = [];

  enEjecucionshow: TareaCasoMixedModel[] = [];

  finalizadoshow: TareaCasoMixedModel[] = [];

  permisosStr: string = null;

  urlApi = this.env.URL_API;
  users; //Toma los usuarios
  constructor(
    private env: EnvService,
    private route: ActivatedRoute,
    private router: Router,
    public _casos: CasoTareaService,
    public _tareacaso: TareaCasoService,
    public _tareas: TareasService,
    private socket: Socket,
    private _snackBar: MatSnackBar,
    private _notificacion: NotificacionService,
    public dialog: MatDialog,
    public rolesService: RolService,
    public _users: UserService,
    public _rolesPermisosService: RolesPermisosService,
    private cd: ChangeDetectorRef
  ) {
    this.idCaso = this.route.snapshot.paramMap.get('id');

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        //do something on end activity
        // this.route.snapshot.paramMap.get('id');
        this.idCaso = this.route.snapshot.paramMap.get('id');

        this.permisosStr = this.rolesService.permisos.toString();
        this.socket.on('recarga_tareas', (msj: { ok: boolean }) => {
          if (!this.processingInit) {
            this.updateTareas();
          }
        });

        this.init();
      }
    });

    this.init();
  }

  initVar: boolean = false;
  ngOnInit() { }

  get canRequestRevision() {
    let caso = this.caso;
    return (
      caso.estado !== 'Bloqueado' &&
      caso.estado !== 'Finalizado' &&
      !caso.aprobacion &&
      (this.permisosStr.includes('Analista de Casos Asuntos Externos') ||
        this.permisosStr.includes('Analista de Casos Asuntos Internos') ||
        this.permisosStr.includes('Analista de Casos Inteligencia') ||
        this.permisosStr.includes('Analista de Gestión de Fraudes') ||
        this.permisosStr.includes('analystRas') ||
        (this.permisosStr.includes('Admininistrador Casos de inteligencia') &&
          caso.tipo_caso === 'Gestión de casos VIP')) &&
      this.enEjecucionshow.length === 0 &&
      this.pendientePorRealizarshow.length === 0 &&
      caso.solucion === 'No Determinado' &&
      (caso.tipo_caso === 'Retención de fondos' ||
        caso.tipo_caso === 'Investigación de asuntos internos' ||
        caso.tipo_caso === 'Detección y Análisis de Fraudes' ||
        (caso.tipo_caso === 'Gestión Administrativa de Fraudes' &&
          caso.requiereDobleAprobacion) ||
        caso.tipo_caso == 'RAS' ||
        caso.tipo_caso === 'Gestión de casos VIP')
    );
  }

  //Textos que cambian si el tipo de caso es externos

  async init() {
    this.caso = await this._casos
      .getById(this.idCaso)
      .pipe(first())
      .toPromise();

    this.updateTareas();
  }

  async updateTareas() {
    this.processingInit = true;
    this.resetTareas();
    const tareasCaso: TareaCasoModel[] = await this._tareacaso
      .getByCaso(this.idCaso)
      .pipe(first())
      .toPromise();
    this.tareasCaso = tareasCaso;
    await Promise.all(
      tareasCaso.map(async (tareacaso: TareaCasoModel) => {
        if (tareacaso.idTarea) {
          const tarea: TareaCasoMixedModel = await this._tareas
            .getById(tareacaso.idTarea)
            .pipe(first())
            .toPromise();
          // MixedModel mezclando modelos
          tarea.estado_caso = tareacaso.estado;
          tarea.tareacasoId = tareacaso._id;
          tarea.observaciones_text = tareacaso.observaciones_text;
          tarea.files = tareacaso.files;
          tarea.lastUser = tareacaso.lastUser;
          tarea.orden_prioridad = tareacaso.orden_prioridad;
          tarea.estafa = tareacaso.estafa;
          tarea.personType = this.caso.personType;
          tarea.personalInternoInvolucrado =
            tareacaso.personalInternoInvolucrado;
          tarea.createdAt = tareacaso.createdAt;
          tarea.updatedAt = tareacaso.updatedAt;

          if (tareacaso.data) tarea.data = tareacaso.data;
          if (tarea.titulo !== 'Aprobar Evaluación del Especialista') {
            this.tareas.push(tarea);
            this.tareasOriginal.push(tarea);
          }
        }
      })
    );

    await this.ordenartareas();
  }

  resetTareas() {
    this.tareas = [];
    this.tareasOriginal = [];
    this.pendientePorRealizar = [];
    this.enEjecucion = [];
    this.finalizado = [];
  }

  async ordenartareas() {
    this.tareas.map((tarea: TareaCasoMixedModel) => {
      if (
        tarea.estado_caso === 'Pendiente de realizar' &&
        this.pendientePorRealizar.find((o) => o.titulo == tarea.titulo) ==
        undefined
      )
        this.pendientePorRealizar.push(tarea);
      if (
        tarea.estado_caso === 'En Ejecución' &&
        this.enEjecucion.find((o) => o.titulo == tarea.titulo) == undefined
      )
        this.enEjecucion.push(tarea);
      if (
        tarea.estado_caso === 'Finalizado' &&
        this.finalizado.find((o) => o.titulo == tarea.titulo) == undefined
      )
        this.finalizado.push(tarea);
    });

    this.pendientePorRealizar = this.pendientePorRealizar.sort(
      (a: any, b: any) => {
        if (!a.orden_prioridad) a.orden_prioridad = 99999999;
        if (!b.orden_prioridad) b.orden_prioridad = 99999999;
        return a.orden_prioridad - b.orden_prioridad;
      }
    );
    this.enEjecucion = this.enEjecucion.sort((a: any, b: any) => {
      if (!a.orden_prioridad) a.orden_prioridad = 9999999;
      if (!b.orden_prioridad) b.orden_prioridad = 9999999;
      return a.orden_prioridad - b.orden_prioridad;
    });
    this.finalizado = this.finalizado.sort((a: any, b: any) => {
      if (!a.orden_prioridad) a.orden_prioridad = 9999999;
      if (!b.orden_prioridad) b.orden_prioridad = 9999999;
      return a.orden_prioridad - b.orden_prioridad;
    });
    this.setOrdenPrioridad();
  }

  setOrdenPrioridad() {
    this.pendientePorRealizar.map(async (tarea: any, i: number) => {
      tarea.orden_prioridad = i + 1;
      delete tarea._id;
      // const res = await this._tareacaso.putOrden(tarea.tareacasoId, tarea)
      //   .pipe(first()).toPromise()
    });
    this.enEjecucion.map(async (tarea: any, i: number) => {
      tarea.orden_prioridad = i + 1;
      delete tarea._id;
      // await this._tareacaso.put(tarea.tareacasoId, tarea)
      //   .pipe(first()).toPromise()
    });
    this.finalizado.map(async (tarea: any, i: number) => {
      tarea.orden_prioridad = i + 1;
      delete tarea._id;
      // await this._tareacaso.put(tarea.tareacasoId, tarea)
      //   .pipe(first()).toPromise()
    });
    this.finalizarProcesamientoInit();
  }

  finalizarProcesamientoInit() {
    this.pendientePorRealizarshow = this.pendientePorRealizar;
    this.enEjecucionshow = this.enEjecucion;
    this.finalizadoshow = this.finalizado;
    this.processingInit = false;
    this.cd.detectChanges();
    if (this.tareas.length === 0 && !this.initVar)
      this.caseInformation.addTasks();
    this.initVar = true;
  }

  async resetOrden() {
    let promises = [];
    promises.push(
      this.enEjecucion.map(async (tarea: any, i: number) => {
        tarea.orden_prioridad = i + 1;
        delete tarea._id;
        await this._tareacaso
          .putOrden(tarea.tareacasoId, tarea)
          .pipe(first())
          .toPromise();
      })
    );
    promises.push(
      this.pendientePorRealizar.map(async (tarea: any, i: number) => {
        tarea.orden_prioridad = i + 1;
        delete tarea._id;
        await this._tareacaso
          .putOrden(tarea.tareacasoId, tarea)
          .pipe(first())
          .toPromise();
      })
    );
    promises.push(
      this.finalizado.map(async (tarea: any, i: number) => {
        tarea.orden_prioridad = i + 1;
        delete tarea._id;
        await this._tareacaso
          .putOrden(tarea.tareacasoId, tarea)
          .pipe(first())
          .toPromise();
      })
    );
    await Promise.all(promises);
  }
  //GET USERS
  async getUsers() {
    const response: any = await this._users.getUsers().toPromise();
    this.users = response.payload;
    // GERENTE DE INTRNOS
    // this.users = this.users.filter((data)=> {
    //   return data.id_roles == 7 ;
    // })
    this._rolesPermisosService
      .takeUser(['Administrador Casos de Asuntos Internos'])
      .subscribe((response) => {
        // for(let userid of response.payload.data){
        // }
        this.users = response.payload.data;
      });
    console.log(this.users);
  }

  allowFinishCandidateVerification(title: string, form: any): boolean {
    if (title != 'Verificación Candidato' || !form) return false;

    return form.antecedentes &&
      form.elegible &&
      form.figura &&
      form.laboro &&
      form.localidad &&
      form.soporte &&
      form.tiene_cuenta &&
      form.validas_referencias &&
      form.validos
      ? true
      : false;
  }

  isCaseAnalyst(tarea_titulo: string = ''): boolean {
    const caseType = this.caso.tipo_caso;
    if (
      //caso es pecifico  que no puede ser ejecutado por analistas
      caseType == 'Recuperación de fondos: cuenta externa' &&
      this.permisosStr.includes('Analista de Casos Asuntos Internos')
    ) {
      this._snackBar.open(`Error: caso disponible solo para gerentes`, 'x');
      return false;
    }
    if (
      this.permisosStr.includes('Analista de Casos Asuntos Internos') ||
      this.permisosStr.includes('Analista de Casos Asuntos Externos') ||
      this.permisosStr.includes('Analista de Gestión de Fraudes') ||
      this.permisosStr.includes('Analista de Casos Inteligencia') ||
      this.permisosStr.includes('analystRas')
    ) {
      return true;
    }
    if (
      caseType == 'Gestión de casos VIP' &&
      this.permisosStr.includes('Admininistrador Casos de inteligencia')
    ) {
      return true;
    }
    if (
      caseType == 'Recuperación de fondos: cuenta externa' &&
      this.permisosStr.includes('Administrador Casos de Asuntos Internos')
    ) {
      return true;
    }

    if (
      [
        'Rol de Guardia',
        'Autorización de transacciones',
        'Validar Documento',
        'Investigación Pre Empleo',
      ].includes(caseType) &&
      this.permisosStr.includes('Administrador Casos de Asuntos Externos')
    ) {
      return true;
    }
    if (
      'Detección y Análisis de Fraudes' == caseType &&
      this.permisosStr.includes('Supervisor Gestión de Fraudes') &&
      tarea_titulo == 'Determinar Procedencia del Caso'
    ) {
      return true;
    }
    this._snackBar.open(`Error: su rol no es de analista`, 'x');
    return false;
  }

  caseIsRunning(): boolean {
    const { estado } = this.caso;
    if (estado === 'En Ejecución') {
      return true;
    }
    let message =
      estado === 'Por Asignar'
        ? `Error: este caso aún se encuentra Sin Comenzar`
        : `Error: este caso no se encuentra en Ejecución`;

    this._snackBar.open(message, 'Cerrar');
    return false;
  }

  isobservationsDone(tarea: any): boolean {
    if (!tarea.observaciones) return true;
    if (!tarea.observaciones_text || tarea.observaciones_text.length < 20) {
      this._snackBar.open(
        `Error: la observacion de la tarea es menor a 20 caracteres`,
        'Cerrar'
      );
      return false;
    }
    return true;
  }
  async drop(event: CdkDragDrop<any[]>, columna: string) {
    const tarea = event.previousContainer.data[event.previousIndex];

    if (!this.caseIsRunning()) return;

    if (!this.isCaseAnalyst(tarea.titulo)) return;

    const { titulo, data } = tarea;

    if (columna != 'Finalizado') {
      this.moveTareaColumn(event, columna);
      return;
    }

    let permitirFinalizar = this.allowFinishCandidateVerification(titulo, data);

    if (titulo == 'Verificación Candidato' && !permitirFinalizar) {
      this._snackBar.open(`Complete los datos de la tarea`, 'Cerrar');
      return;
    }

    if (!this.isobservationsDone(tarea)) return;

    this.moveTareaColumn(event, columna);
  }

  async moveTareaColumn(event: CdkDragDrop<any[]>, columna: string) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
    const tarea = event.container.data[event.currentIndex];
    await this.modificarColumnaIndex(
      event.currentIndex + 1,
      columna,
      tarea.titulo
    );
    tarea.orden_prioridad = event.currentIndex + 1;
    await this.resetOrden();

    await this._tareacaso
      .updateColumn(tarea.tareacasoId, columna)
      .pipe(first())
      .toPromise();

    this.caso = await this._casos
      .getById(this.caso._id)
      .pipe(first())
      .toPromise();

    this.caso.historial.push({
      usuario: `${sessionStorage.getItem('correo')}`,
      realizo: `Paso la tarea '${tarea.titulo}' a '${columna}' prioridad ${event.currentIndex + 1
        }`,
      date: new Date(),
    });
    await this._casos.put(this.caso._id, this.caso).pipe(first()).toPromise();
  }

  async modificarColumnaIndex(i: number, columna: string, titulo: string) {
    if (columna == 'Pendiente de realizar')
      this.pendientePorRealizar.map((tarea: any) => {
        if (tarea.orden_prioridad >= i && titulo !== tarea.titulo) {
          tarea.orden_prioridad += 1;
        }
        return tarea;
      });
    if (columna == 'En Ejecución')
      this.enEjecucion.map((tarea: any) => {
        if (tarea.orden_prioridad >= i && titulo !== tarea.titulo) {
          tarea.orden_prioridad += 1;
        }
        return tarea;
      });
    if (columna == 'Finalizado') {
      this.finalizado.map((tarea: any) => {
        if (tarea.orden_prioridad >= i && titulo !== tarea.titulo) {
          tarea.orden_prioridad += 1;
        }
        return tarea;
      });
    }
  }

  openTarea(tarea: TareaCasoMixedModel) {
    let administradorCasos = this.permisosStr.includes(
      'Administrador de Casos'
    );
    if (this.caso.estado == 'En Ejecución' || administradorCasos) {
      tarea.idCaso = this.caso._id;
      let maxWidth = '800px';
      if (tarea.titulo == 'Registrar Hipotesis.') maxWidth = '1000px';
      const ref = this.dialog.open(VerTareaComponent, {
        data: tarea,
        width: '90vw',
        maxWidth,
        maxHeight: '95vh',
        disableClose: true,
        panelClass: 'modalVerTarea',
      });
      ref.afterClosed().subscribe(() => this.init());
    } else {
      this._snackBar.open(`El caso actual no se encuentra en ejecución`, `x`);
    }
  }

  filter() {
    this.updateTareas();
  }

  requeridoChange() {
    this.requerido = !this.requerido;
    if (this.requerido) {
      this.tareas = this.tareas.filter((tarea) =>
        tarea.requerido ? true : false
      );
      this.pendientePorRealizar = this.pendientePorRealizar.filter((tarea) =>
        tarea.requerido ? true : false
      );
      this.enEjecucion = this.enEjecucion.filter((tarea) =>
        tarea.requerido ? true : false
      );
      this.finalizado = this.finalizado.filter((tarea) =>
        tarea.requerido ? true : false
      );
      this.ordenartareas();
    } else this.filter();
  }
}
